var _g, _text, _path, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResendImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_71_12",
    "data-name": "Component 71 \\u2013 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.652,
    height: 39,
    viewBox: "0 0 110.652 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_839",
    "data-name": "Rectangle 839",
    fill: "#002581",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.652,
    height: 39,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109.652,
    height: 38,
    rx: 4.5,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "resend_Invitation",
    "data-name": "resend Invitation",
    transform: "translate(72.375 16)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.014,
    y: 0
  }, "resend"), /*#__PURE__*/React.createElement("tspan", {
    x: -24.58,
    y: 14
  }, "Invitation"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4206",
    "data-name": "Path 4206",
    d: "M1622,55.72c0,5.413-5.026,9.8-11.225,9.8a12.675,12.675,0,0,1-3.76-.563c-1.732-.537-2.961,2.027-8.229,2.417,4.285-3.725,3.134-5.616,2.865-5.944a8.944,8.944,0,0,1-2.1-5.71c0-5.413,5.026-9.8,11.226-9.8S1622,50.307,1622,55.72Z",
    transform: "translate(-1587.018 -37.374)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(21.982 24.273)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendImage);
export default __webpack_public_path__ + "static/media/ResendImage.028c109394aaba4775d540805e215c67.svg";
export { ForwardRef as ReactComponent };